










import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import OrganizationAdminList from "@/components/OrganizationAdminList.vue";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";
import AuthModule from "@/store/auth";

@Component({
  components: {
    Header,
    OrganizationAdminList,
    Footer,
  },
})
export default class OAdminList extends CheckOrganizationAdminLogin {
  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }
}
